module.exports = __webpack_public_path__ + "static/media/pg-service-image.39627e2e.jpg";